export enum Action {
  View = 'view',
  Edit = 'edit',
  Delete = 'delete',
  Review = 'review',
  SendBackAsWfp = 'send_back_as_wfp',
  SendBackAsCpc = 'send_back_as_cpc',
  SendBackFlaAsWfp = 'send_back_fla_as_wfp',
  Reject = 'reject',
  SendBackAsApprover = 'send_back_as_approver',
  Submit = 'submit',
  SendBackToDraftAsCpc = 'send_back_to_draft_as_cpc',
  SendToPartnerApproval = 'send_to_partner_approval',
  SendBackToFinalizationFromPartnerApproval = 'send_back_to_finalization_from_partner_approval',
  SendToApprovalFromPartnerApproval = 'send_to_approval_from_partner_approval',
  SendBackToDraft = 'send_back_to_draft',
  SendBackAmendmentToDraft = 'send_back_to_draft_am',
  Resend = 'resend',
  SendBackAmendmentToDraftAsCpc = 'send_back_to_draft_as_cpc_am'
}

export enum SubmitActionLabel {
  SubmitAsPartner = 'Submit',
  FinalizeFla = 'Finalize',
  ApproveFla = 'Approve',
  Resend = 'Resend link'
}
